import { changeFormatPrice } from './utils';
$(document).ready(function() {
  localStorage.clear();
  let courseCount = 0;
  let todayMinPeople  = 2;
  $.datepicker.regional['ja'] = {
    closeText: "閉じる",
    prevText: "&#x3C;前",
    nextText: "次&#x3E;",
    currentText: "今日",
    monthNames: [ "1月","2月","3月","4月","5月","6月",
      "7月","8月","9月","10月","11月","12月" ],
    monthNamesShort: [ "1月","2月","3月","4月","5月","6月",
      "7月","8月","9月","10月","11月","12月" ],
    dayNames: [ "日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日" ],
    dayNamesShort: [ "日","月","火","水","木","金","土" ],
    dayNamesMin: [ "日","月","火","水","木","金","土" ],
    weekHeader: "週",
    dateFormat: "yy/mm/dd",
    firstDay: 0,
    isRTL: false,
    showMonthAfterYear: true,
    yearSuffix: "年",
    minDate: new Date()
  };

  $.datepicker.setDefaults($.datepicker.regional['ja']);

  function reCalculatePositionOfCalender() {
  if ($('.ui-datepicker:visible').length) {
      const input = $('#date');
      const offset = input.offset();
      const height = input.outerHeight();
      
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        $('.ui-datepicker').css({
          top: offset.top + height + 'px',
          left: offset.left + 'px',
        });
      } else {
        $('.ui-datepicker').css({
          position: "absolute",
          top: offset.top + height + 'px',
          left: offset.left + 'px',
        });
      }
    }
  }
  
  $('#search_shop_date, #sp_search_shop_date').datepicker({
    appendTo: '#modal-timetable',
    onSelect: function (e) {
      handleDate(e)
    },
    position: {
      my: "left top",
      at: "right bottom",
      of: "#datepicker"
    },
  });

  $('#date').datepicker({
    appendTo: '#modal-timetable',
    onSelect: function(e) {
      $(this).trigger('changeDate');
    },


  });

  $('.input_wrapper.calender').click(function () {
   $(this).find('input').trigger('focus')
  });

  const openDatepicker = $('#open-datepicker');
  const dateInput = $('#date');

  if (openDatepicker.length > 0 && dateInput.length > 0) {
    openDatepicker.val(dateInput.val());

    openDatepicker.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      dateInput.trigger('focus');
    });
  }

  $("#date").on("focus", function() {
    setTimeout(reCalculatePositionOfCalender(), 10);
  });

  $(window).on("scroll", function () {
    setTimeout(reCalculatePositionOfCalender(), 10);
  })

  $(window).resize(function(){
    setTimeout(reCalculatePositionOfCalender(), 10);
  });

  $('#clear_search, #clear_search_sp').on('click', (e) => {
    $(e.target).closest('form').find('.form_input').val('');
    $('#sp_area option').remove();
    $('#area option').remove();
    $("#sp_area").append($('<option>').html('選択してください').val(''));
    $("#area").append($('<option>').html('選択してください').val(''));
  });

  $('#frm-search-shop, #frm-search-shop-sp').submit( (e) => {
    $('<input />').attr('type', 'hidden')
      .attr('name', 'sort')
      .attr('value', $('.search-shop-result #sort').val())
      .appendTo(e.target);
    return true;
  });

  $('.search-shop-result #sort').on('change', () => {
    $('#frm-search-shop').submit();
  })
  function handleDate(e) {
    var side_menu_form = $("#search_shop_date, #sp_search_shop_date").closest("form").attr('id');
      $("#search_shop_date").val(e);
      $("#sp_search_shop_date").val(e);
     if (side_menu_form == 'frm-search-shop-sp' || side_menu_form == 'frm-search-shop')
     {
       $("#frm-search-shop-sp").valid();
       $("#frm-search-shop").valid();
     }
  }

  function fetchCourseData(options = {}) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: "get",
        url: `/shops/courses`,
        data: {
          "shop_id":  $("#bespo_shop_id").val(),
          "number_of_people": options.number_of_people,
          "date": options.date
        },
        success: function (res) {
          resolve(res.courses || []);
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          resolve([]);
        }
      });
    });
  }

  function isOtherIndustryZeroPrice(course) {
      const shopIndustryInfo = document.getElementById("shopIndustryInfo")
      if (!shopIndustryInfo) return false;
      const isOtherIndustry = shopIndustryInfo.dataset.isOtherIndustry === 'true'

      return isOtherIndustry && Number(course.price || 0) === 0 && Number(course.price_max || 0) === 0
  }

  async function getCourses() {
    $("#loading_course").show();
    const courses = await fetchCourseData();
    $("#loading_course").hide();
    if (courses.length == 0) {
      $("#titleCourse").hide();
    } else {
      $("#titleCourse").show();
    }
    courseCount = courses?.length;
    courses.forEach(course => {
      const courseElement = $(`
        <div class="container-course">
          <div class="img-course-container">
            <img src="${course.first_image}">
          </div>
          <div class="content-course">
          <div class="course-main-content">
              <p class="category-container">${
                course.categories.map(c => `${c.name}`).join(' | ')
              }</p>
              <div class="name-course">${escapeHTML(course.name)}</div>
              ${isOtherIndustryZeroPrice(course)  ? `` : `
              ${!course.price_max || course.price_max === course.price ? `
                  <span class="course-price">¥ ${changeFormatPrice(course.price)}${$("#txt_tax").val()}</span>
                 `: `
                  <span class="course-price">¥ ${changeFormatPrice(course.price)} ~ ¥ ${changeFormatPrice(course.price_max)}${$("#txt_tax").val()}</span>
                 `} 
              `}
          </div>
            <md-text-button class="btn-detail-course" type="button">${$("#txt_button_detail_course").val()}</md-text-button>
          </div>
        </div>
      `);
      courseElement.find('.btn-detail-course').on('click', () => {
        openPopupDetailCourse(course)
      });

       $("#listCourses").append(courseElement);
      reCalculatePositionOfCalender()
    });
  }


  function emptyPopup() {
    $("#nameCourse").empty();
    $("#prCourse").empty();
    $("#priceCourse").empty();
    $("#timePeriod").empty();
    $("#numberCustomerLimit").empty();
    $("#stayTime").empty();
    $("#cookingItems").empty();
    $("#description").empty();
    $("#cancellation_policy").empty();
    $("#imageCourse").empty();
    $(`#courseCategories`).empty();
    $("#courseImagesCarousel .carousel-indicators").empty();
    $("#courseImagesCarousel").show(); // Ensure carousel container is visible by default
  }

  function emptyPlanPopup() {
    $("#name_plan").empty();
    $("#pr_plan").empty();
    $("#price_plan").empty();
    $("#timePeriod_plan").empty();
    $("#numberCustomerLimit_plan").empty();
    $("#stayTime_plan").empty();
    $("#cookingItems_plan").empty();
    $("#description_plan").empty();
    $("#cancellation_policy_plan").empty();
    $("#image_plan").empty();
  }

  function initCourseCarousel() {
    let currentCourseSlide = 0;
    let isCourseAutoPlay = true;
    let courseAutoPlayInterval;
    const totalCourseSlides = document.querySelectorAll('#courseImagesCarousel .carousel-item').length;
    const courseCarousel = document.getElementById('courseImagesCarousel');
    const courseCarouselItems = document.querySelectorAll('#courseImagesCarousel .carousel-item');
    const courseIndicators = document.querySelectorAll('#courseImagesCarousel .carousel-indicators li');
    const nextButton = document.querySelector('#courseImagesCarousel .carousel-control-next');
    const prevButton = document.querySelector('#courseImagesCarousel .carousel-control-prev');
    // Don't initialize carousel functionality if there's only one slide
    if (totalCourseSlides <= 1) {
      return;
    }

    function startCourseAutoPlay() {
      if (isCourseAutoPlay && totalCourseSlides > 1) {
        courseAutoPlayInterval = setInterval(() => {
          nextCourseSlide();
        }, 4000);
      }
    }

    function stopCourseAutoPlay() {
      clearInterval(courseAutoPlayInterval);
    }

    function updateCourseSlide() {
      // Update carousel items
      courseCarouselItems.forEach((item, index) => {
        item.classList.toggle('active', index === currentCourseSlide);
      });

      // Update indicators
      courseIndicators.forEach((indicator, index) => {
        indicator.classList.toggle('active', index === currentCourseSlide);
      });
    }

    function nextCourseSlide() {
      currentCourseSlide = (currentCourseSlide + 1) % totalCourseSlides;
      updateCourseSlide();
    }

    function previousCourseSlide() {
      currentCourseSlide = (currentCourseSlide - 1 + totalCourseSlides) % totalCourseSlides;
      updateCourseSlide();
    }
    if (prevButton) {
        prevButton.addEventListener('click', () => {
            previousCourseSlide();
            stopCourseAutoPlay(); // Stop autoplay when user manually navigates
        });
    }
    
    if (nextButton) {
        nextButton.addEventListener('click', () => {
            nextCourseSlide();
            stopCourseAutoPlay(); // Stop autoplay when user manually navigates
        });
    }

    function goToCourseSlide(slideIndex) {
      currentCourseSlide = slideIndex;
      updateCourseSlide();
    }

    // Add click events to indicators
    courseIndicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => goToCourseSlide(index));
    });

    // Touch/swipe support for carousel
    let startX = null;
    let startY = null;
    let isCarouselDragging = false;
    
    if (courseCarousel) {
      courseCarousel.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isCarouselDragging = false;
      }, { passive: true });

      courseCarousel.addEventListener('touchmove', (e) => {
        if (!startX || !startY) return;
        
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const deltaX = Math.abs(currentX - startX);
        const deltaY = Math.abs(currentY - startY);
        
        // Only engage carousel if horizontal movement is significantly more than vertical
        // AND we've moved enough horizontally
        if (deltaX > 30 && deltaX > deltaY * 2) {
          isCarouselDragging = true;
          e.preventDefault();
          e.stopPropagation();
        }
        // Otherwise, let the parent handle the scroll
      }, { passive: false });

      courseCarousel.addEventListener('touchend', (e) => {
        if (!startX || !startY) return;
        
        // Only trigger carousel change if we were actually carousel dragging
        if (isCarouselDragging) {
          let endX = e.changedTouches[0].clientX;
          let diffX = startX - endX;
          
          if (Math.abs(diffX) > 50) {
            e.preventDefault();
            e.stopPropagation();
            
            if (diffX > 0) {
              nextCourseSlide();
            } else {
              previousCourseSlide();
            }
          }
        }
        
        startX = null;
        startY = null;
        isCarouselDragging = false;
      }, { passive: false });

      // Pause on hover, resume on mouse leave
      courseCarousel.addEventListener('mouseenter', () => {
        if (isCourseAutoPlay) {
          stopCourseAutoPlay();
        }
      });

      courseCarousel.addEventListener('mouseleave', () => {
        if (isCourseAutoPlay) {
          startCourseAutoPlay();
        }
      });
    }

    updateCourseSlide();
    startCourseAutoPlay();
  }

  function openPopupDetailCourse(course) {
    emptyPopup();

    // Handle course images with carousel
    const courseImages = [];
    if (course.course_images != null && course.course_images.length > 0) {
      course.course_images.forEach(element => {
        courseImages.push(element.image_path);
      });
    } else if (course.first_image) {
      courseImages.push(course.first_image);
    }

    // Create carousel structure
    const carouselIndicators = $("#courseImagesCarousel .carousel-indicators");
    const carouselInner = $("#imageCourse");
    
    carouselIndicators.empty();
    carouselInner.empty();

    if (courseImages.length > 0) {
      if (courseImages.length > 1) {
        // Multiple images - use carousel
        carouselIndicators.show();
        courseImages.forEach((_, index) => {
          const indicator = $(`<li data-slide-to="${index}" ${index === 0 ? 'class="active"' : ''}></li>`);
          carouselIndicators.append(indicator);
        });

        // Create carousel items
        courseImages.forEach((imagePath, index) => {
          const carouselItem = $(`
            <div class="carousel-item ${index === 0 ? 'active' : ''}">
              <img src="${imagePath}" alt="Course image" />
            </div>
          `);
          carouselInner.append(carouselItem);
        });


      } else {
        // Single image - use simple structure
        carouselIndicators.hide();
        const singleImageItem = $(`
          <div class="carousel-item active">
            <img src="${courseImages[0]}" alt="Course image" />
          </div>
        `);
        carouselInner.append(singleImageItem);
      }
    } else {
      // No images - hide the carousel container
      carouselIndicators.hide();
      $("#courseImagesCarousel").hide();
    }
    // Initialize course carousel
    initCourseCarousel();
    if (course.categories && course.categories.length > 0) {
      const categoriesHtml = course.categories.map(c => `<span class="category-item">${c.name}</span>`).join('');
      $(`#courseCategories`).html(categoriesHtml);
    }
    $("#nameCourse").html(`${escapeHTML(course.name)}`)
    const coursePR = course.pr == null ? '' : course.pr;
    $("#prCourse").html(`${escapeHTML(coursePR)}`)

    const isMaxPriceNUllOrEqualToPrice = !course.price_max || course.price_max === course.price ?
        `¥ ${changeFormatPrice(course.price)}${$("#txt_tax").val()}`:
        `¥ ${changeFormatPrice(course.price)} ~ ¥ ${changeFormatPrice(course.price_max)}${$("#txt_tax").val()}`;

      const courseDetailElement = document.getElementById("courseDetailPrice")
      if(courseDetailElement){
          if (isOtherIndustryZeroPrice(course)) {
              courseDetailElement.style.display='none'
          } else {
              courseDetailElement.style.display=''
          }
      }
    $("#priceCourse").html(isMaxPriceNUllOrEqualToPrice)


    if (course.has_limit_customer) {
      $("#numberCustomerLimit").html(`${course.number_customer_min}～${course.number_customer_max} ${$("#txt_people").val()}`)
    } else {
      $("#numberCustomerLimit").html($("#txt_all_party_size").val())
    }
    if (course.has_reservable_time) {
      $("#timePeriod").html(`${course.reservable_form}～${course.reservable_to}`)
    } else {
      $("#timePeriod").html($("#txt_all_time").val())
    }
    $("#stayTime").html(`${course.stay_time} ${$("#txt_minute").val()}`)
    if(course.item_description && course.item_description != null) {
    $("#itemDescription").parent(".info").parent(".course_info").attr("style", "display: block !important;");
    $("#itemDescription").html(`${escapeHTML(course.item_description == null ? '' : course.item_description)}`)
    } else {
      $("#itemDescription").parent(".info").parent(".course_info").attr("style", "display: none !important;");
    }
    if(course.item_remark && course.item_remark != null) {
      $("#itemDescriptionSupplement").parent(".info").parent(".course_info").attr("style", "display: block !important;");
      $("#itemDescriptionSupplement").html(`${escapeHTML(course.item_remark == null ? '' : course.item_remark)}`)
    } else {
      $("#itemDescriptionSupplement").parent(".info").parent(".course_info").attr("style", "display: none !important;");
    }
    if( course.description && course.description != null) {
      $("#description").parent(".course_info").attr("style", "display: block !important;");
      $("#description").html(`${escapeHTML(course.description == null ? '' : course.description)}`)
    } else {
      $("#description").parent(".course_info").attr("style", "display: none !important;");
    }
    if(course.cancellation_policy && course.cancellation_policy != null) {
      $("#cancellation_policy").parent(".course_info").attr("style", "display: block !important;");
      $("#cancellation_policy").html(`${escapeHTML(course.cancellation_policy == null ? '' : course.cancellation_policy)}`)
    } else {
      $("#cancellation_policy").parent(".course_info").attr("style", "display: none !important;");
    }
    $("#course_detail_id").val(course.id);

    const shouldHideFooter = course.hide_footer ||
        !course.is_available_for_reservation ||
        (course.reservation_number_of_people_limit_during_the_course_period > 0 &&
            !course.is_reservation_available_today)
    
    $("#detail-course .modal-footer").toggle(!shouldHideFooter)

    $("#detail-course").modal('show')
  }
  /**
   *  formate datetime (yyyy/mm/dd hh:mm)
   * @param value {string}
   * @returns {`${number}/${number}/${number}  ${string}: ${string}`}
   */
  const formatDate = (value) => {
    if(!value) return

    const date = new Date(value);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, 0);
    const day = (date.getDate()).toString().padStart(2, 0);
    const hours = date.getHours().toString().padStart(2, 0);
    const minutes = date.getMinutes().toString().padStart(2, 0);

    return `${year}/${month}/${day}  ${hours}:${minutes}`
  }
  function openPopupDetailPlan(plan) {
    emptyPlanPopup()

    if (plan.image != null) {

      $("#image_plan").append(`<div class="img-course-modal">
                                  <img src="${plan.image.url}" /></div>`)
    }

    $("#name_plan").html(`${escapeHTML(plan.name)}`)
    const coursePR = plan.pr == null ? '' : plan.pr;
    $("#pr_plan").html(`${escapeHTML(coursePR)}`)
    $("#price_plan").html(`¥ ${changeFormatPrice(plan.price.selling_price)}${$("#txt_tax").val()}&nbsp;${getDiscountAmount(plan.price) !== '' ? '| ' + getDiscountAmount(plan.price) : '' }`)
      $("#numberCustomerLimit_plan").html(`${plan.number_of_people_min}～${plan.number_of_people_max}${$("#txt_people").val()}`)

    if (plan.usage_time) {
      $("#timePeriod_plan").html(`${plan.usage_time?.start_time}～${plan.usage_time?.end_time}`)
    } else {
      $("#timePeriod_plan").html($("#txt_all_time").val())
    }
    $("#stayTime_plan").html(`${plan.available_length_of_stay} ${$("#txt_minute").val()}`)

    // provision period
    if(plan && plan.offer_period) {
      const { start_time , end_time } = plan.offer_period;
      let reservablePeriod = '';
      const provisionPeriodElement = $("#reservablePeriod_plan");

      if(!start_time && !end_time) {
        // hide the reservablePeriod row if both start_time and end_time is null
        provisionPeriodElement.parent('.course_info').attr('style', 'display: none !important;');
      } else {
        // show the reservablePeriod row if the one of the start_time or end_time is not null
        provisionPeriodElement.parent('.course_info').attr('style', '');
        if(end_time && !start_time) {
          reservablePeriod = `〜 ${formatDate(end_time)}`;
        } else if(start_time && !end_time) {
          reservablePeriod = `${formatDate(start_time)} 〜`;
        } else {
          reservablePeriod = `${formatDate(start_time)} 〜 ${formatDate(end_time)}`;
        }
      }

      provisionPeriodElement.html(reservablePeriod);
    }

    $("#itemDescription_plan").html(`${escapeHTML(plan.item_description == null ? '' : plan.item_description)}`)
    if (plan.explanation && plan.explanation != null) {
      $("#description_plan").closest(".course_info").css("cssText", "display: block !important;");
      $("#description_plan").html(`${escapeHTML(plan.explanation)}`)
    }
    else{
      $("#description_plan").closest(".course_info").css("cssText", "display: none !important;");
    }
    if (plan.notes && plan.notes != null) {
      $("#remarks_plan").closest(".course_info").css("cssText", "display: block !important;");
      $("#remarks_plan").html(`${escapeHTML(plan.notes)}`)
    }
    else{
      $("#remarks_plan").closest(".course_info").css("cssText", "display: none !important;");
    }
    if (plan.all_you_can_drink_menu && plan.all_you_can_drink_menu != null) {
      $("#all_you_can_drink_menu_plan").closest(".course_info").css("cssText", "display: block !important;");
      $("#all_you_can_drink_menu_plan").html(`${escapeHTML(plan.all_you_can_drink_menu)}`)
    }
    else{
      $("#all_you_can_drink_menu_plan").closest(".course_info").css("cssText", "display: none !important;");
    }

    if (plan.plan_related_services && plan.plan_related_services.length > 0){
      $("#tags-container").closest(".course_info").css("cssText", "display: block !important;");
      $("#tags-container").html(`${plan.plan_related_services.map(c => `<span class="category-item">${c.plan_name}</span>`).join('')}`)
    }
    else{
      $("#tags-container").closest(".course_info").css("cssText", "display: none !important;");
    }

    $("#detail-plan").modal('show')
    if (plan.hide_footer) {
      $("#detail-plan .modal-footer").hide();
    } else {
      $("#detail-plan .modal-footer").show();
    }
  }

  function escapeHTML(htmlStr) {
    if (htmlStr == null) return '';

    return htmlStr.replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
  }

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function getCalendar(options = {}) {
    if (document.querySelector('.seat_calendar') === null) return;

    const start_date = options.start_date ? new Date(options.start_date) : new Date();
    const date_range = 14;
    const locale = $("#language").val() === 'ja' ? 'ja-JP' : 'en-US';
    $("#seat_calendar").empty();
    const seat_day_elements = {};
    let month = null;
    const formatDate = (date) => {
      if (month === date.getMonth()) {
        return `${date.getDate()}`
      } else {
        month = date.getMonth();
        return `${date.getMonth()+1}/${date.getDate()}`
      }
    }
    for (let i = 0; i < date_range; i++) {
      const date = addDays(start_date, i);
      const date_element = $(`
        <div class="seat_day">
          <div class="weekday ${date.getDay() === 0 ? 'sun' : '' } ${date.getDay() === 6 ? 'sat' : '' }">${date.toLocaleDateString(locale, {weekday: 'short'})}</div>
          <button disabled>
            <div class="date">${formatDate(date)}</div>
            <div class="availability"></div>
          </button>
        </div>
      `);
        date_element.find('button').on('click', function () {
            openTimetableModal({
                date: date.yyyymmdd(),
                number_of_people: $(this).data('number_of_people')
            });
        });
      seat_day_elements[date.yyyymmdd().replace(/\//g, "-")] = date_element;
      $("#seat_calendar").append(date_element);
      if (i === 6) {
        $("#seat_calendar").append('<div class="flex_break"></div>');
      }
    }

    window.calendar_start_date = start_date;
    if (start_date <= new Date()) {
      $(".prev-week").css('visibility', 'hidden');
    } else {
      $(".prev-week").css('visibility', 'visible');
    }

    $("#loading_seat_calendar").show();
    jQuery.ajax({
      type: "get",
      url: `/shops/calendar`,
      data: {
        "shop_id": $("#bespo_shop_id").val(),
        "start_date": start_date.yyyymmdd(),
        "end_date": addDays(start_date, date_range - 1).yyyymmdd(),
      },
      success: function (res) {
        $("#loading_seat_calendar").hide();
        const todayDate = new Date().toLocaleDateString('sv-SE')
        res.data.forEach(e => {
          if (e.reservable) {
            seat_day_elements[e.date]?.find('button').removeAttr('disabled');
            seat_day_elements[e.date]?.find('.availability').html(`
    <svg width="20" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5 7.5C14.5 8.68669 14.1481 9.84672 13.4888 10.8334C12.8295 11.8201 11.8924 12.5891 10.7961 13.0433C9.69971 13.4974 8.49332 13.6162 7.32943 13.3847C6.16554 13.1532 5.09645 12.5818 4.25733 11.7426C3.41822 10.9035 2.84677 9.83443 2.61526 8.67054C2.38375 7.50665 2.50257 6.30025 2.95669 5.2039C3.41082 4.10754 4.17986 3.17047 5.16655 2.51118C6.15324 1.85189 7.31328 1.5 8.49997 1.5C10.0913 1.5 11.6174 2.13214 12.7426 3.25736C13.8678 4.38258 14.5 5.9087 14.5 7.5Z" stroke="var(--md-sys-color-primary)" stroke-width="2.52632" stroke-linecap="round" stroke-linejoin="round"/>         
      </svg>

    `);
          } else {
            seat_day_elements[e.date]?.find('button').attr('disabled', true);
            seat_day_elements[e.date]?.find('.availability').html(`
      <svg width="17" height="17" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.6429 1.70825L11.4346 0.5L6.64285 5.29175L1.8511 0.5L0.642853 1.70825L5.4346 6.5L0.642853 11.2917L1.8511 12.5L6.64285 7.70825L11.4346 12.5L12.6429 11.2917L7.8511 6.5L12.6429 1.70825Z" fill="var(--md-sys-color-outline)"/>
      </svg>

    `);
          }
          if (e.date === todayDate) {
            todayMinPeople = e.min_people || 2;
          }
            const btn = seat_day_elements[e.date]?.find('button');
            if (!btn || btn.length === 0) return;
            btn.data('number_of_people', e.min_people);
        });
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        $("#loading_seat_calendar").hide();
      }
    });
  }

  function openTimetableModal(options = {}) {
    // redirect to tablecheckweb if needed
    if(document.querySelector('#redirect_to_tablecheckweb').value === 'true') {
      jQuery.ajax({
        type: "post",
        url: `/shops/tablecheckweb`,
        data: {
          "id_code": $("#shop_id_code").val(),
          "date": options.date || null,
          "from_fb_insta": $("#from_fb_insta").val(),
        },
        success: function (res) {
          location.href = res.url;
        },
      });
      reCalculatePositionOfCalender()
      return;
    }

    // set default input
    const defaultDate = options.date || new Date().yyyymmdd();
    const defaultPerson = options.number_of_people || 2;
    $("#date").val(defaultDate);
    if (openDatepicker.length > 0 && dateInput.length > 0) {
      openDatepicker.val(dateInput.val());
    }
    $("#number_of_people").val(defaultPerson);

    // reset timetable
    $("#seat-list").empty();
    $("#not-availability").hide();
    $("#booking_options").show();
    $("#modal-divider").show();
    $("#only-seat-radio").hide();
    $("#list-timetable-courses").empty();
    $("#new-reservation-btn").prop('disabled', true).addClass('disabled');

    $("#modal-timetable").modal('show')
    getTimetableSeats({
      ...options
    });
  }
  function resetPlanSeatData(){
    $(`input[name="seat_type_id"]`).prop("checked", false);
    $("#seat_name").val('')
  }

  function getTimetableSeats(options = {}) {
    $("#loading_timetable").show();
    jQuery.ajax({
      type: "get",
      url: `/shops/timetable`,
      data: {
        "shop_id": $("#bespo_shop_id").val(),
        "number_of_people": $("#number_of_people").val(),
        "date": $("#date").val(),
      },
      success: function (res) {
        $("#loading_timetable").hide();
        $("#seat-list").empty();
        res.data ||= [];
        if (res.data.length === 0) {
          $("#not-availability").show();
          $("#booking_options").hide();
          $("#modal-divider").hide();
          $(".seat_option").hide();

          $("#only-seat-radio").hide(); 
          $("#only_seat").prop('checked', false);
          $("#list-timetable-courses").empty();
        } else {
          $("#not-availability").hide();
          $("#booking_options").show();
          $("#modal-divider").show();
          $("#only-seat-radio").show();
          $(".seat_option").show();

          $("#only_seat").prop('checked', true).trigger('change');
        }
        const seats = res.data.map(time => {
          const date = new Date(time);
          const button =  $(`
            <button type="button" class="time">${date.toTimeString().split(' ')[0].substring(0, 5)}</button>
          `);
          button.on('click', () => {
            $("#only_seat_container").removeClass('inactive');
            $("#seat-list .time").removeClass('active');
            button.addClass('active');
            if($('#shop_type').val()==='usen'){
              getTimetablePlans(time);
            }
            else{
              getTimetableCourses(time,options.course_id);
            }
          });
          return button;
        });
        seats.forEach(seat => {
          $("#seat-list").append(seat);
        });

        // select default time
        if (seats.length > 0) {
          let selectedSeat = seats[Math.floor((seats.length-1)/2)]
          if (options.time) {
            selectedSeat = seats.find(seat => seat.text() === options.time);
          }
          selectedSeat.focus().click();
        }
        activeReservationBtn();
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        $("#loading_timetable").hide();
      }
    });
  }
  function fetchPlanData(options = {}) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: "get",
        url: '/shops/usen_plans',
        data: {
          "shop_id": $("#bespo_shop_id").val(),
          "number_of_people": options.number_of_people,
          "date": options.date
        },
        success: function (res) {
          resolve(res.usen_plans || []);
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          resolve([]);
        }
      });
    });
  }

  async function getPlans() {
    $("#loading_course").show();
    const plans = await fetchPlanData();
    $("#loading_course").hide();
    if (plans && plans.plans && plans.plans.length === 0) {
      $("#titleCourse").hide();
    } else {
      $("#titleCourse").show();
    }
    courseCount = plans?.plans?.length || 0;
    plans.plans.forEach(plan => {
      const courseElement = $(`
        <div class="container-course">
          <div class="img-course-container clickable-detail">
            <img src="${plan.image.url}">
          </div>
          <div class="content-course">
          <div class="course-main-content">
               ${renderPlanTags(plan)}
              <div class="name-course clickable-detail">${escapeHTML(plan.name)}</div>
              <span class="course-price">¥ ${changeFormatPrice(plan.price.market_price)} <span>${$("#txt_tax").val()}</span></span>
              ${ parseFloat(plan.price.market_price) > parseFloat(plan.price.selling_price) ? 
                `<span class='course-price' style='color:var(--md-sys-color-error);font-weight=var(--md-sys-typescale-body-small-enhanced-weight);'>¥ ${changeFormatPrice(plan.price.selling_price)}<span >${$("#txt_tax").val()}</span></span> 
                <span style='color:var(--md-sys-color-error);font-weight=var(--md-sys-typescale-label-small-weight);'>&nbsp;${getDiscountAmount(plan.price) !== '' ? '| ' + getDiscountAmount(plan.price) : '' }
                </span>` : ''
              }
            </div>
           <md-text-button class="btn-detail-course clickable-detail">${$("#txt_button_detail_course").val()}</md-text-button>
          </div>
          <div id="reserve_plan_${plan.id}" class="reserve_plan"></div>
        </div>
       
      `);
      courseElement.find('.clickable-detail').on('click', () => {
        openPopupDetailPlan(plan);
      });
      $("#listCourses").append(courseElement);
    });
  }

  async function getTimetableCourses(time,selected_course_id = null) {
    const selectedCourseId = selected_course_id || localStorage.getItem('selected_course_id');
    $("#loading_timetable_course").show();
    $("#timetable").val(time);
    $("input[name=course_ids]:checked").prop("checked",false)  //reset previous selected course
    $("#new-reservation-btn").prop('disabled', true).addClass('disabled'); 
    const courses = await fetchCourseData({date: time, number_of_people: $("#number_of_people").val()});
    $("#loading_timetable_course").hide();
    $("#only_seat").prop('checked', true).trigger('change');
    $("#list-timetable-courses").empty();
    courses.forEach(course => {
      const courseElement = $(`
         <div class="container-course" id="course-container_${course.id}">
         <div class="container-course_radio">
          <label class="radio-btn-align" for="course-change_${course.id}">
            <input class="radio" id="course-change_${course.id}" type="radio" value="${course.id}" name="course_ids">
            <label class="radio_label cursor-pointer" for="course-change_${course.id}"></label>
          </label>
          <div class="img-course-container">
            <img src="${course.first_image}">
          </div>
          </div>
          <div>
          <div class="content-course">
            <p class="category-container">${
              course.categories.map(c => `<span class="category-item">${c.name}</span>`).join('')
            }</p>
            <div class="name-course">${escapeHTML(course.name)}</div>
            <div class="course-price-content">
             ${isOtherIndustryZeroPrice(course)  ? `` : `
                ${!course.price_max || course.price_max === course.price ? `
                  <span class="course-price">¥ ${changeFormatPrice(course.price)}${$("#txt_tax").val()}</span>
                 `: `
                  <span class="course-price">¥ ${changeFormatPrice(course.price)} ~ ¥ ${changeFormatPrice(course.price_max)}${$("#txt_tax").val()}</span>
                 `}
             `}
             </div>
             </div>
             <md-text-button class="btn-detail-course" type="button">${$("#txt_button_detail_course").val()}</md-text-button>
          </div>
        </div>
      `);
      courseElement.find('.btn-detail-course').on('click', () => {
        course.hide_footer = true;
        openPopupDetailCourse(course)
      });
      //set selected course if user come from course detail
      if(course.id == selectedCourseId){
        courseElement.find('input[name=course_ids]').prop("checked",true);
        $("#only_seat_container").removeClass("active");
        $("#list-timetable-courses .container-course").removeClass("active");
        $("#name_course").val(course.name);
        $("#price_course").val(course.price);
        $("#max_price_course").val(course.price_max);
        $("#course_cancellation_policy").val(course.cancellation_policy);
        $("#course_id").val(course.id);
        $("#only_seat_container").addClass("inactive");
        courseElement.addClass("active");
      }

      courseElement.find('input[name=course_ids]').on('change', () => {
        localStorage.setItem('selected_course_id', course.id);
        $("#only_seat_container").removeClass("active");
        $("#list-timetable-courses .container-course").removeClass("active");
        $("#name_course").val(course.name);
        $("#price_course").val(course.price);
        $("#max_price_course").val(course.price_max);
        $("#course_cancellation_policy").val(course.cancellation_policy);
        $("#course_id").val(course.id);
        courseElement.addClass("active");
        $("#only_seat_container").addClass("inactive");
        activeReservationBtn();
      });
      $("#list-timetable-courses").append(courseElement);
      activeReservationBtn();
      reCalculatePositionOfCalender()
    });
  }

  async function getTimetablePlans(time) {
    const timetableCoursesContainer = document.querySelector(".list-timetable-courses")
    const skeletonLoadingContainer = $(".skeleton_loading__inner_container")

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        /**
         * height based on the visible height of the timetable Courses list
         */
        skeletonLoadingContainer.css('height', `${entry.intersectionRect.height}px`)
      });
    }, { threshold: 0 });

    observer.observe(timetableCoursesContainer);

    $("#not-availability").hide();
    $("#booking_options").show();
    $("#modal-divider").show();
    $("#loading_timetable_course").show();
    $("#timetable").val(time);
    addSubmitEvent(time)
    const plans = await fetchPlanData({date: time, number_of_people: $("#number_of_people").val()});
    $("#loading_timetable_course").hide();
    $("#list-timetable-courses").empty();
    if (plans && plans.plans && plans.plans.length === 0 ) {
      if (plans.shop_has_plan){
        $("#not-availability").show();
        $("#booking_options").hide();
        $("#modal-divider").hide();
        $(".seat_option").hide();
        $("#only-seat-radio").hide();
        $("#only_seat").prop('checked', false);
        $("#new-reservation-btn").prop('disabled', true).addClass('disabled');
      }else{
        $("#only-seat-radio").show();
        $("#not-availability").hide();
        $("#booking_options").show();

        $("#modal-divider").show();
        $(".seat_option").show();
        $("#only_seat").prop('checked', true).trigger('change');
        $("#new-reservation-btn").prop('disabled', false).removeClass('disabled');
        $("#form-to-reservation").off("submit");        
      }
    } else {
      $("#only-seat-radio").hide();
      $("#not-availability").hide();
      $("#booking_options").show();
      $("#modal-divider").show();

      validateReservationBtnPlan();
    }
    plans.plans.forEach(plan => {
      const planElement = $(`
        <div class="container-course" id="container-plan">
        <div class="plan-container">
          <label class="radio-btn-align" for="course-change_${plan.id}">
            <input class="radio" id="plan-change_${plan.id}" type="radio" value="${plan.id}" name="plan_id">
            <label class="radio_label cursor-pointer" for="plan-change_${plan.id}"></label>
          </label>
          <div class="img-course-container clickable-detail">
            <img src="${plan.image.url}">
          </div>
            <div class="content-course">
                  <div class="course-main-content">
                      ${renderPlanTags(plan)}
                      <div class="name-course clickable-detail">${escapeHTML(plan.name)}</div>
                      <span class="course-price">¥ ${changeFormatPrice(plan.price.market_price)}${$("#txt_tax").val()}</span>
                      ${ parseFloat(plan.price.market_price) > parseFloat(plan.price.selling_price) ? 
                        `<span class='course-price' style='color:var(--md-sys-color-error);font-weight=var(--md-sys-typescale-body-small-enhanced-weight);'>¥ ${changeFormatPrice(plan.price.selling_price)}${$("#txt_tax").val()}</span> 
                        <span style='color:var(--md-sys-color-error);font-weight=var(--md-sys-typescale-label-small-weight);'>&nbsp;${getDiscountAmount(plan.price) !== '' ? '| ' + getDiscountAmount(plan.price) : '' }
                        </span>` : ''
                      }
                  </div>
                <md-text-button class="btn-detail-course clickable-detail" type="button">${$("#txt_button_detail_course").val()}</md-text-button>
            </div>
          </div>
              <div id="reserve_plan_${plan.id}" class="reserve_plan">
                  <div id="plan_table_${plan.id}" class="plan_table">
                  </div>
              </div>
        </div>
      `);
      plan.seat_types?.length > 0 && plan.seat_types.forEach(seat => {
        const seatElement = $(`
          <div class="plan_seat_type">
            <div>
              <input class="radio" id="seat-change_${plan.id}_${seat.id}" type="radio" value="${seat.id}" name="seat_type_id">
              <label class="radio_label cursor-pointer" for="seat-change_${plan.id}_${seat.id}"></label>
            </div>
            <div>
              <span>${seat.name}</span>
            </div>
            ${!plan.price.extra_charge_applicable ? 
              `<div>
                <span>${getSeatCharge(seat)}</span>
              </div>` 
              : ''
            }
          </div>
        `)

        seatElement.find(`#seat-change_${plan.id}_${seat.id}`).on('click',function(){
          $("#seat_name").val(seat.name)
          $("#seat_charge_fee").val(!plan.price.extra_charge_applicable ? getSeatCharge(seat) : '')
          validateReservationBtnPlan()
        })

        planElement.find(`#plan_table_${plan.id}`).append(seatElement)
      })

      planElement.find('.clickable-detail').on('click', () => {
        plan.hide_footer = true;
        openPopupDetailPlan(plan)
      });
      planElement.find('input[name=plan_id]').on('change', function(){
        $("#plan_id").val(plan.id);
        updatePlanData(plan)
        $('.reserve_plan').css("display", "none");
        planElement.find(`#reserve_plan_${plan.id}`).css("display", "block");
        resetPlanSeatData()
        validateReservationBtnPlan();
      });

      $("#list-timetable-courses").append(planElement);
    });
  }

  function addSubmitEvent(time){
    $("#form-to-reservation").off("submit");
    $("#form-to-reservation").on("submit", async function(event) {
      event.preventDefault();
      const success = await handlePlanData({date: time, number_of_people: $("#number_of_people").val()});
      if (!success) return;
      this.submit()
    })
  }

  function updatePlanData(plan){
    $("#plan_name").val(plan.name);
    $("#plan_notes").val(plan.notes);
    $("#plan_price").val(getPlanPrice(plan));
    $("#free_text_placeholder").val(plan.free_text_initial_text);
    $("#free_text_caption").val(plan.free_text_input_caption);
    $("#free_text_notes").val(plan.free_text_notes);
    $("#free_text_input_type").val(plan.free_text_input_type);
    $("#course_cancellation_policy").val(plan.cancellation_policy);
  }

  function renderPlanTags(plan) {
    const tagMap = {
      jp:{
        popular: '👑 人気No.1',
        recommended: '😃 オススメ'
      },
      en:{
        popular: '👑 No. 1 in popularity',
        recommended: '😃 Recommended'
      }
    };

    return plan?.label ? `<p class="category-container">${$("#language").val() === 'ja' ? tagMap.jp[plan.label] : tagMap.en[plan.label]}</p>` : '';
  }

  function getDiscountAmount(price){
    if( parseFloat(price.market_price) <= parseFloat(price.selling_price) ){
      return ''
    }

    if (price.discount_symbol == '%'){
      return  Math.round(
        ((parseFloat(price.market_price) -
          parseFloat(price.selling_price)) /
          parseFloat(price.market_price)) *
          100
      ) + '% OFF'
    }
    else{
      return Math.floor(
          parseFloat(price.market_price) -
          parseFloat(price.selling_price)
        ) + '円 OFF'
    }
  }

  function activeReservationBtn() {
    if (($("input[name=course_ids]:checked").val() != null || $("input[name=plan_id]:checked").val() != null) && $("#timetable").val()) {
      $("#new-reservation-btn").prop('disabled', false).removeClass('disabled');
    } else {
      $("#new-reservation-btn").prop('disabled', true).addClass('disabled');
    }
  }

  function validateReservationBtnPlan() {
    const hasPlanSelected = $("input[name=plan_id]:checked").val() != null;
    const hasSeatTypeSelected = $("input[name=seat_type_id]:checked").val() != null;
    const hasTimetable = $("#timetable").val() !== "";
  
    if (hasTimetable && hasPlanSelected && hasSeatTypeSelected) {
      $("#new-reservation-btn").prop('disabled', false).removeClass('disabled');
    } else {
      $("#new-reservation-btn").prop('disabled', true).addClass('disabled');
    }
  }

  function validateReservationBtn(){
    if( $("#timetable").val() == "" || $("#timetable").val() == null || $("#timetable").val() == undefined ){
      $("#new-reservation-btn").prop('disabled', true).addClass('disabled');
    }
    else{
      $("#new-reservation-btn").prop('disabled', false).removeClass('disabled');
    }
  }

  function getPlanPrice(plan){
    let plan_price = plan?.price?.selling_price
    if(plan_price === 0){
      return plan_price;
    }
    let charge_included = plan?.price?.extra_charge_applicable

    if($("#language").val() === 'ja'){
      return `¥ ${plan_price} (税込) ${charge_included ? 'チャージ料金込み': ''}`
    }
    else {
      return `¥ ${plan_price} (tax included) ${charge_included ? 'Charge fee included': ''}`
    }
  }

  function getSeatCharge(seat) {
    const language = $("#language").val() === 'ja' ? 'jp' : 'en';
    
    const translations = {
      jp: {
        chargePerTable: 'チャージ料金：１テーブルあたり',
        chargePerPerson: 'チャージ料金：お一人様',
        noCharge: 'チャージ料金：なし',
        taxIncluded: '（税込）'
      },
      en: {
        chargePerTable: 'Charge fee: Per table ',
        chargePerPerson: 'Charge fee: Per person ',
        noCharge: 'Charge fee: No charge',
        taxIncluded: ' (tax included)'
      }
    };

    const t = translations[language];
    if (seat?.charge_fee == 0 || seat?.charge_fee == "0") {
      return t.noCharge
    }
    switch (seat.charge_type) {
      case 'per_table':
        return seat.charge_fee_type === "percent" 
          ? `${t.chargePerTable}${seat?.charge_fee}%`
          : `${t.chargePerTable}¥${seat?.charge_fee}${t.taxIncluded}`;
      case 'per_person':
        return seat.charge_fee_type === "percent"
          ? `${t.chargePerPerson}${seat?.charge_fee}%`
          : `${t.chargePerPerson}¥${seat?.charge_fee}${t.taxIncluded}`;
      default:
        return t.noCharge;
    }
  }

   async function handlePlanData(planData){
    try{
      const plans = await fetchPlanData({date: planData.date, number_of_people: planData.number_of_people});
      const plan_id = $("#plan_id").val();
      const plan = plans.plans.find(plan => plan.id == plan_id);
      updatePlanData(plan);
      return true
    }
    catch(error){
      return false
    }
  }

  // For shops/:id page and for update container
  if ($("#update-container").length > 0)
  {
    //setTimeout added to ensure the time select wrapper works on IOS version 15.3 and below
    setTimeout(() => {
    $(".reload-timetable").on('change changeDate', function(){
      if (openDatepicker.length > 0 && dateInput.length > 0) {
        openDatepicker.val(dateInput.val());
      }
      $("#time-select-wrapper").hide();
      $("#seat-search-btn").show();
      $("#web-reservation-update-btn").hide();
    });
  }, 0);
  }
  
  if($("#page-shop-show").length > 0 ) {
    $(".open-timetable-modal").on('click', (e) => {
      const course_id= e.target.value;
      localStorage.setItem('selected_course_id', course_id);
      $("#detail-course").modal('hide');
      $("#detail-plan").modal('hide');
      if(course_id){
        openTimetableModal({course_id: course_id, number_of_people: todayMinPeople });
      }else{
        openTimetableModal({number_of_people: todayMinPeople });
      }
      reCalculatePositionOfCalender()
    });

    $(".seat_day").on('click', (e) => {
      openTimetableModal({date: $(e.currentTarget).data('date')});
    });
    //setTimeout added to ensure the api refetch works on IOS version 15.3 and below
    setTimeout(() => {
    $(".reload-timetable").on('change changeDate', function(){
      if (openDatepicker.length > 0 && dateInput.length > 0) {
        openDatepicker.val(dateInput.val());
      }
      getTimetableSeats();
    });
  }, 0);

    $("#only_seat").on('change', () => {
      $("#list-timetable-courses .container-course").removeClass("active");
      $("#name_course").val('');
      $("#course_cancellation_policy").val('');
      $("#plan_id").val('');
      $("#plan_name").val('');
      $("#plan_price").val('');
      $("#free_text").val('');
      $("#free_text_caption").val('');
      $("#free_text_notes").val('');
      $("#free_text_input_type").val('');
      $("#free_text_placeholder").val('');
      resetPlanSeatData()
      validateReservationBtn()
      $('.reserve_plan').hide()
    });

    $(".prev-week-div").on('click', () => {
      getCalendar({start_date: addDays(window.calendar_start_date, -14)});
    });
    $(".next-week-div").on('click', () => {
      getCalendar({start_date: addDays(window.calendar_start_date, 14)});
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('access') === 'list') {
      const date = urlParams.get('date');
      const time = urlParams.get('time');
      const number_of_people = urlParams.get('number_of_people');
      openTimetableModal({date: date, time: time, number_of_people: number_of_people});
    }

    getCalendar();
    if($('#shop_type').val()==='usen'){
      getPlans()
    }
    else{
      getCourses();
    }
  }
  $('#modal-timetable').on('hide.bs.modal', function () {
    localStorage.removeItem('selected_course_id');
  });
  function isMobile() {
    return window.innerWidth < 768;
  }
  function isSmallScreen() {
    return window.innerWidth <= 320;
  }
function initBottomSheetBehavior() {
    const modal = $('#modal-timetable');
    const modalDialog = modal.find('.modal-content');
    const modalHandle = modal.find('.modal-handle');
    const modalBody = modal.find('.modal-body');
    
    const COLLAPSED_HEIGHT = 77;
    const EXPANDED_HEIGHT = 90;
    const DRAG_THRESHOLD = 10;
    const ACTION_THRESHOLD = 50;
    const CLOSE_THRESHOLD = 100;
    
    let dragState = {
        isDragging: false,
        startY: 0,
        currentHeight: isSmallScreen() ? 'expanded' : 'collapsed'
    };
    
    function toggleBackgroundScroll(prevent) {
        if (!isMobile()) return;
        
        if (prevent) {
            const scrollY = window.pageYOffset;
            Object.assign(document.body.style, {
                position: 'fixed',
                top: `-${scrollY}px`,
                width: '100%',
                overflow: 'hidden'
            });
        } else {
            const scrollY = document.body.style.top;
            Object.assign(document.body.style, {
                position: '',
                top: '',
                width: '',
                overflow: ''
            });
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY) * -1);
            }
        }
    }
    
    function setModalHeight(heightPercent, animate = true) {
        if (!isMobile()) return;
        
        const clampedHeight = Math.max(COLLAPSED_HEIGHT, Math.min(EXPANDED_HEIGHT, heightPercent));
        const pixelHeight = (window.innerHeight * clampedHeight) / 100;
        
        modalDialog.css({
            'transition': animate ? 'height 0.3s ease-out, transform 0.3s ease-out' : 'none',
            'height': `${pixelHeight}px`,
            'position': 'fixed',
            'bottom': '0'
        });
        
        dragState.currentHeight = clampedHeight >= EXPANDED_HEIGHT ? 'expanded' : 'collapsed';
    }
    
    function calculateHeightFromDrag(deltaY, isExpanded) {
        const vh = window.innerHeight;
        const dragRatio = Math.min(Math.abs(deltaY) / (vh * 0.3), 1);
        const heightDiff = EXPANDED_HEIGHT - COLLAPSED_HEIGHT;
        
        if (deltaY > 0) { // Dragging down
            return isExpanded ? EXPANDED_HEIGHT - (heightDiff * dragRatio) : COLLAPSED_HEIGHT;
        } else { // Dragging up
            return isExpanded ? EXPANDED_HEIGHT : COLLAPSED_HEIGHT + (heightDiff * dragRatio);
        }
    }
    
    function handleTouch(e) {
        if (!isMobile()) return;
        
        const touch = e.touches?.[0] || e.changedTouches?.[0];
        if (!touch) return;
        
        const isHandle = modalHandle[0]?.contains(e.target);
        
        switch (e.type) {
            case 'touchstart':
                if (isHandle) {
                    dragState.isDragging = false;
                    dragState.startY = touch.clientY;
                    modalDialog.css('transition', 'none');
                }
                break;
                
            case 'touchmove':
                if (isHandle && dragState.startY) {
                    const deltaY = touch.clientY - dragState.startY;
                    
                    if (!dragState.isDragging && Math.abs(deltaY) > DRAG_THRESHOLD) {
                        dragState.isDragging = true;
                    }
                    
                    if (dragState.isDragging) {
                        e.preventDefault();
                        const isExpanded = dragState.currentHeight === 'expanded';
                        
                        if (deltaY > 0 && !isExpanded) {
                            const transform = Math.min(deltaY, window.innerHeight * 0.5);
                            modalDialog.css('transform', `translateY(${transform}px)`);
                          } else if (deltaY < 0 && !isExpanded && courseCount < 1) {
                          // Prevent drag up movement when courseCount is less than 1
                            return;
                        } else {
                            const newHeight = calculateHeightFromDrag(deltaY, isExpanded);
                            setModalHeight(newHeight, false);
                        }
                    }
                }
                break;
                
            case 'touchend':
                if (dragState.isDragging && isHandle) {
                    const deltaY = touch.clientY - dragState.startY;
                    const isExpanded = dragState.currentHeight === 'expanded';
                    
                    modalDialog.css('transition', 'height 0.3s ease-out, transform 0.3s ease-out');
                    
                    if (deltaY > 0) { // Dragging down
                        if (isExpanded) {
                            setModalHeight(deltaY >= ACTION_THRESHOLD ? COLLAPSED_HEIGHT : EXPANDED_HEIGHT);
                        } else {
                            if (deltaY >= CLOSE_THRESHOLD) {
                                $('#ui-datepicker-div').hide();
                                modal.modal('hide');
                            } else {
                                modalDialog.css('transform', 'translateY(0)');
                                setModalHeight(COLLAPSED_HEIGHT);
                            }
                        }
                    } else if (deltaY < 0) { // Dragging up
                        const absDelta = Math.abs(deltaY);
                        // Disable drag up when courseCount is less than 1
                        if (!isExpanded && absDelta >= ACTION_THRESHOLD && courseCount >= 1) {
                            setModalHeight(EXPANDED_HEIGHT);
                        } else {
                            modalDialog.css('transform', 'translateY(0)');
                            setModalHeight(isExpanded ? EXPANDED_HEIGHT : COLLAPSED_HEIGHT);
                        }
                    }
                }
                
                dragState.isDragging = false;
                dragState.startY = 0;
                break;
        }
    }
    
    const touchEvents = ['touchstart', 'touchmove', 'touchend'];
    touchEvents.forEach(event => {
        modalDialog[0]?.addEventListener(event, handleTouch, { passive: false });
    });
    
    modal.on({
        'show.bs.modal': () => {
            modalBody.css({
                'overflow-y': 'auto',
                '-webkit-overflow-scrolling': 'touch',
                'overscroll-behavior': 'contain',
                'touch-action': 'pan-y'
            });
            toggleBackgroundScroll(true);
        },
        
        'hide.bs.modal': () => toggleBackgroundScroll(false),
        
        'hidden.bs.modal': () => {
            modalDialog.css({
                'transform': '',
                'transition': '',
                'height': ''
            });
            dragState.isDragging = false;
            dragState.currentHeight = 'collapsed';
            toggleBackgroundScroll(false);
        },
        
        'click': (e) => {
            if (isMobile() && e.target === modal[0]) {
                modal.modal('hide');
            }
        }
    });
    
    modal.data('cleanup', () => {
        touchEvents.forEach(event => {
            modalDialog[0]?.removeEventListener(event, handleTouch);
        });
    });
}

  
  // Initialize bottom sheet behavior
  initBottomSheetBehavior();

  // Hash change handling for modals on mobile for navigation
  if (isMobile()) {
      const openedModals = [];
      $('#modal-timetable').on('show.bs.modal', function(e) {
            openedModals.push('#modal-timetable');
            window.location.hash = "reservation";
        });
          $('#detail-course').on('show.bs.modal', function(e) {
              openedModals.push('#detail-course');
              window.location.hash = "course";
        });
        $('#detail-plan').on('show.bs.modal', function(e) {
              openedModals.push('#detail-plan');
              window.location.hash = "plan";
        });
        $('#modal-timetable').on('hidden.bs.modal', function(e) {
            openedModals.splice(openedModals.indexOf('#modal-timetable'),1);
            if(openedModals.length === 0) {
              history.pushState("", document.title, window.location.pathname + window.location.search);
            }
            else {
              const lastModal = openedModals[openedModals.length - 1];
              if (lastModal === '#detail-course') {
                window.location.hash = "course";
              } else if (lastModal === '#detail-plan') {
                window.location.hash = "plan";
              } else if (lastModal === '#modal-timetable') {
                window.location.hash = "reservation";
              }
            }
        });
        $('#detail-course').on('hidden.bs.modal', function(e) {
            openedModals.splice(openedModals.indexOf('#detail-course'),1);
            if(openedModals.length === 0) {
              history.pushState("", document.title, window.location.pathname + window.location.search);
            }
            else {
              const lastModal = openedModals[openedModals.length - 1];
              if (lastModal === '#detail-course') {
                window.location.hash = "course";
              } else if (lastModal === '#detail-plan') {
                window.location.hash = "plan";
              } else if (lastModal === '#modal-timetable') {
                window.location.hash = "reservation";
              }
            }
        });
        $('#detail-plan').on('hidden.bs.modal', function(e) {
            openedModals.splice(openedModals.indexOf('#detail-plan'),1);
            if(openedModals.length === 0) {
              history.pushState("", document.title, window.location.pathname + window.location.search);
            }
            else {
              const lastModal = openedModals[openedModals.length - 1];
              if (lastModal === '#detail-course') {
                window.location.hash = "course";
              } else if (lastModal === '#detail-plan') {
                window.location.hash = "plan";
              } else if (lastModal === '#modal-timetable') {
                window.location.hash = "reservation";
              }
            }
        });


        $(window).on('hashchange', function (event) {
            if(window.location.hash != "#reservation" && openedModals.length === 1) {
                $('#modal-timetable').modal('hide');
            }
            if(window.location.hash != "#course") {
                $('#detail-course').modal('hide');
            }
            if(window.location.hash != "#plan") {
                $('#detail-plan').modal('hide');
            }
        });
  }
  //multiple modal background scroll issue
  $(document).on('hidden.bs.modal', function () {
    if ($('.modal.show').length) {
      $('body').addClass('modal-open');
    }
  })
});

